module.exports = __webpack_public_path__ + "img/pl.067f1be4.svg";